const value = {
    title: 'Feature unavailable',
    message:
      'We are doing our best to get the service back up and running. If you have any questions, please contact our support team:',
  };

export default value;
